export default "__VITE_ASSET__CLKee5ff__"